module.exports = __webpack_public_path__ + "fk.svg?5e30840a77641f770587626bcff0639d";